// extracted by mini-css-extract-plugin
export default {"scrollbar-wrapper":"vk9sI0","scrollbarWrapper":"vk9sI0"};